import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppInterceptorService } from './core/services/app-interceptor.service';
import { GlobalErrorHandlerService } from './core/services/global-error-handler.service';
import { LoadingService } from './core/services/loading.service';
import { SessionmanagementService } from './core/services/sessionmanagement.service';
import { AuthenticationService } from './core/services/authentication.service';
import { SharedMaterialModule } from './shared/shared-material.module';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";


@NgModule({
  bootstrap: [AppComponent],

  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    SharedMaterialModule
],
 
schemas: [
  CUSTOM_ELEMENTS_SCHEMA
],
  providers: [
     provideHttpClient(withInterceptorsFromDi()),
    {
      // processes all errors
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptorService,
      multi: true
    }, LoadingService, SessionmanagementService, AuthenticationService
  ],
})
export class AppModule { }
